module.exports = __webpack_public_path__ + "img/15.596e5a42.png";